"use strict";

var _regeneratorRuntime = require("/home/ubuntu/frontend/production/fleetadvise/fleetmd/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/ubuntu/frontend/production/fleetadvise/fleetmd/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/ubuntu/frontend/production/fleetadvise/fleetmd/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var caseless = require('caseless');

var qs = require('qs');

var urlJoin = require('url-join'); // eslint-disable-next-line import/no-unassigned-import


require('cross-fetch/polyfill'); // eslint-disable-next-line import/no-unassigned-import


require('abortcontroller-polyfill/dist/polyfill-patch-fetch');

var Interceptor = require('./interceptor');

var methods = ['get', 'head', 'post', 'put', 'del', 'options', 'patch'];
var respProperties = {
  readOnly: ['headers', 'ok', 'redirected', 'status', 'statusText', 'type', 'url', 'bodyUsed'],
  writable: ['useFinalURL'],
  callable: ['clone', 'error', 'redirect', 'arrayBuffer', 'blob', 'formData', 'json', 'text']
};

function createFrisbeeResponse(origResp) {
  var resp = {
    originalResponse: origResp
  };
  respProperties.readOnly.forEach(function (prop) {
    return Object.defineProperty(resp, prop, {
      value: origResp[prop]
    });
  });
  respProperties.writable.forEach(function (prop) {
    return Object.defineProperty(resp, prop, {
      get: function get() {
        return origResp[prop];
      },
      set: function set(value) {
        origResp[prop] = value;
      }
    });
  });
  var callable = null;
  respProperties.callable.forEach(function (prop) {
    Object.defineProperty(resp, prop, {
      value: (callable = origResp[prop], typeof callable === 'function' && callable.bind(origResp))
    });
  });
  var headersObj = {};
  origResp.headers.forEach(function (pair) {
    headersObj[pair[0]] = pair[1];
  });
  Object.defineProperty(resp, 'headersObj', {
    value: headersObj
  });
  return resp;
}

var Frisbee =
/*#__PURE__*/
function () {
  function Frisbee() {
    var _this4 = this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Frisbee);

    this.opts = opts;
    var localAbortController;
    Object.defineProperty(this, 'abortController', {
      enumerable: false,
      get: function get() {
        if (!localAbortController) {
          localAbortController = new AbortController();
          localAbortController.signal.addEventListener('abort', function () {
            // when this is aborted, null out the localAbortController
            // so we'll create a new one next time we need it
            localAbortController = null;
          });
        }

        return localAbortController;
      }
    });
    var localAbortTokenMap = new Map();
    Object.defineProperty(this, 'abortTokenMap', {
      enumerable: false,
      get: function get() {
        return localAbortTokenMap;
      }
    });
    Object.defineProperty(this, 'parseErr', {
      enumerable: false,
      value: opts.parseErr || new Error("Invalid JSON received".concat(opts.baseURI ? " from ".concat(opts.baseURI) : ''))
    });
    this.headers = _objectSpread({}, opts.headers);
    this.arrayFormat = opts.arrayFormat || 'indices';
    this.raw = opts.raw === true;
    if (opts.auth) this.auth(opts.auth);
    methods.forEach(function (method) {
      _this4[method] = _this4._setup(method);
    }); // interceptor should be initialized after methods setup

    this.interceptor = new Interceptor(this, methods); // bind scope to method

    this.auth = this.auth.bind(this);
    this.jwt = this.jwt.bind(this);
    this.abort = this.abort.bind(this);
    this.abortAll = this.abortAll.bind(this);
    this._request = this._request.bind(this);
    this._parseJSON = this._parseJSON.bind(this);
    this._fetch = this._fetch.bind(this);
  }

  _createClass(Frisbee, [{
    key: "abort",
    value: function abort(token) {
      var mapValue = this.abortTokenMap.get(token);

      if (mapValue && mapValue.abortController) {
        mapValue.abortController.abort();
      }
    }
  }, {
    key: "abortAll",
    value: function abortAll() {
      this.abortController.abort();
    }
  }, {
    key: "_setup",
    value: function _setup(method) {
      var _this5 = this;

      return function () {
        var originalPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
        var originalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (originalOptions && typeof originalOptions === 'object') {
          var abortController;

          if (originalOptions.abortToken) {
            // allow to use a single token to cancel multiple requests
            var mapValue = _this5.abortTokenMap.get(originalOptions.abortToken);

            if (!mapValue) {
              mapValue = {
                abortController: new AbortController(),
                count: 0
              };
            }

            mapValue.count++;

            _this5.abortTokenMap.set(originalOptions.abortToken, mapValue);

            abortController = mapValue.abortController;
          } else {
            abortController = new AbortController();
          } // the user has defined their own signal we won't use it directly, but we'll listen to it


          if (originalOptions.signal) {
            originalOptions.signal.addEventListener('abort', function () {
              return abortController.abort();
            });
          } // abort this request whenever this.abortController.abort() gets called - a.k.a. - abortAll()


          _this5.abortController.signal.addEventListener('abort', function () {
            return abortController.abort();
          });

          originalOptions.signal = abortController.signal;
        } // these can't change with interceptors, otherwise we're in weird behaviour land


        var signal = originalOptions.signal,
            abortToken = originalOptions.abortToken;
        return _this5._request({
          method: method,
          originalPath: originalPath,
          originalOptions: originalOptions,
          signal: signal,
          abortToken: abortToken
        });
      };
    }
  }, {
    key: "_request",
    value: function _request(_ref2) {
      var method = _ref2.method,
          originalPath = _ref2.originalPath,
          originalOptions = _ref2.originalOptions,
          signal = _ref2.signal,
          abortToken = _ref2.abortToken;

      var _this = this;

      return (
        /*#__PURE__*/
        function () {
          var _ref = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee() {
            var path,
                options,
                raw,
                noRaw,
                opts,
                c,
                arrayFormat,
                response,
                error,
                mapValue,
                _args = arguments;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    path = _args.length > 0 && _args[0] !== undefined ? _args[0] : originalPath;
                    options = _args.length > 1 && _args[1] !== undefined ? _args[1] : originalOptions;

                    if (!(typeof path !== 'string')) {
                      _context.next = 4;
                      break;
                    }

                    throw new TypeError('`path` must be a string');

                  case 4:
                    if (!(typeof options !== 'object' || Array.isArray(options))) {
                      _context.next = 6;
                      break;
                    }

                    throw new TypeError('`options` must be an object');

                  case 6:
                    if (!(options.abortToken !== abortToken)) {
                      _context.next = 8;
                      break;
                    }

                    throw new Error('abortToken cannot be modified via an interceptor');

                  case 8:
                    if (!(options.signal !== signal)) {
                      _context.next = 10;
                      break;
                    }

                    throw new Error('signal cannot be modified via an interceptor');

                  case 10:
                    raw = options.raw, noRaw = _objectWithoutProperties(options, ["raw"]);
                    opts = _objectSpread({}, noRaw, {
                      headers: _objectSpread({}, _this.headers, options.headers),
                      method: method === 'del' ? 'DELETE' : method.toUpperCase()
                    }); // remove any nil or blank headers
                    // (e.g. to automatically set Content-Type with `FormData` boundary)

                    Object.keys(opts.headers).forEach(function (key) {
                      if (typeof opts.headers[key] === 'undefined' || opts.headers[key] === null || opts.headers[key] === '') delete opts.headers[key];
                    });
                    c = caseless(opts.headers); // in order to support Android POST requests
                    // we must allow an empty body to be sent
                    // https://github.com/facebook/react-native/issues/4890

                    if (!(typeof opts.body === 'undefined' && opts.method === 'POST')) {
                      _context.next = 18;
                      break;
                    }

                    opts.body = '';
                    _context.next = 33;
                    break;

                  case 18:
                    if (!(typeof opts.body === 'object' || Array.isArray(opts.body))) {
                      _context.next = 33;
                      break;
                    }

                    if (!(opts.method === 'GET' || opts.method === 'DELETE')) {
                      _context.next = 25;
                      break;
                    }

                    arrayFormat = _this.arrayFormat;
                    path += "?".concat(qs.stringify(opts.body, {
                      arrayFormat: arrayFormat
                    }));
                    delete opts.body;
                    _context.next = 33;
                    break;

                  case 25:
                    if (!(c.get('Content-Type') && c.get('Content-Type').split(';')[0] === 'application/json')) {
                      _context.next = 33;
                      break;
                    }

                    _context.prev = 26;
                    opts.body = JSON.stringify(opts.body);
                    _context.next = 33;
                    break;

                  case 30:
                    _context.prev = 30;
                    _context.t0 = _context["catch"](26);
                    throw _context.t0;

                  case 33:
                    _context.prev = 33;
                    _context.next = 36;
                    return _this._fetch(path, opts, raw);

                  case 36:
                    response = _context.sent;
                    _context.next = 42;
                    break;

                  case 39:
                    _context.prev = 39;
                    _context.t1 = _context["catch"](33);
                    error = _context.t1;

                  case 42:
                    // update the abortTokenMap
                    mapValue = _this.abortTokenMap.get(options.abortToken);

                    if (mapValue) {
                      if (mapValue.count - 1 === 0) {
                        _this.abortTokenMap.delete(options.abortToken);
                      } else {
                        _this.abortTokenMap.set(options.abortToken, _objectSpread({}, mapValue, {
                          count: --mapValue.count
                        }));
                      }
                    }

                    if (!error) {
                      _context.next = 46;
                      break;
                    }

                    throw error;

                  case 46:
                    return _context.abrupt("return", response);

                  case 47:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[26, 30], [33, 39]]);
          }));

          return function () {
            return _ref.apply(this, arguments);
          };
        }()
      );
    }
  }, {
    key: "_parseJSON",
    value: function _parseJSON(res) {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(typeof res.json === 'function')) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return res.json();

              case 4:
                res.body = _context2.sent;
                _context2.next = 11;
                break;

              case 7:
                _context2.next = 9;
                return res.text();

              case 9:
                res.body = _context2.sent;
                res.body = JSON.parse(res.body);

              case 11:
                // attempt to use better and human-friendly error messages
                if (typeof res.body === 'object' && typeof res.body.message === 'string') {
                  res.err = new Error(res.body.message);
                } else if (!Array.isArray(res.body) && // attempt to utilize Stripe-inspired error messages
                typeof res.body.error === 'object') {
                  if (res.body.error.message) res.err = new Error(res.body.error.message);
                  if (res.body.error.stack) res.err.stack = res.body.error.stack;
                  if (res.body.error.code) res.err.code = res.body.error.code;
                  if (res.body.error.param) res.err.param = res.body.error.param;
                }

                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](0);
                res.err = _this2.parseErr;

              case 17:
                return _context2.abrupt("return", res);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 14]]);
      }))();
    }
  }, {
    key: "_fetch",
    value: function _fetch(path, opts, raw) {
      var _this3 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var fullUri, originalRes, res, contentType;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fullUri = _this3.opts.baseURI ? urlJoin(_this3.opts.baseURI, path) : path;
                _context3.next = 3;
                return fetch(fullUri, opts);

              case 3:
                originalRes = _context3.sent;
                res = createFrisbeeResponse(originalRes);
                contentType = res.headers.get('Content-Type');

                if (!res.ok) {
                  _context3.next = 34;
                  break;
                }

                if (!(raw === true || _this3.raw && raw !== false)) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return", res.originalResponse);

              case 9:
                if (!(contentType && contentType.includes('application/json'))) {
                  _context3.next = 30;
                  break;
                }

                _context3.prev = 10;

                if (!(typeof res.json === 'function')) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 14;
                return res.json();

              case 14:
                res.body = _context3.sent;
                _context3.next = 21;
                break;

              case 17:
                _context3.next = 19;
                return res.text();

              case 19:
                res.body = _context3.sent;
                res.body = JSON.parse(res.body);

              case 21:
                _context3.next = 28;
                break;

              case 23:
                _context3.prev = 23;
                _context3.t0 = _context3["catch"](10);

                if (!(contentType === 'application/json')) {
                  _context3.next = 28;
                  break;
                }

                res.err = _this3.parseErr;
                return _context3.abrupt("return", res);

              case 28:
                _context3.next = 33;
                break;

              case 30:
                _context3.next = 32;
                return res.text();

              case 32:
                res.body = _context3.sent;

              case 33:
                return _context3.abrupt("return", res);

              case 34:
                res.err = new Error(res.statusText); // check if the response was JSON, and if so, better the error
                // (return early if it's not)

                if (!(!contentType || !contentType.includes('application/json'))) {
                  _context3.next = 37;
                  break;
                }

                return _context3.abrupt("return", res);

              case 37:
                return _context3.abrupt("return", _this3._parseJSON(res));

              case 38:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[10, 23]]);
      }))();
    }
  }, {
    key: "auth",
    value: function auth(creds) {
      if (typeof creds === 'string') {
        var index = creds.indexOf(':');
        if (index !== -1) creds = [creds.substr(0, index), creds.substr(index + 1)];
      }

      if (!Array.isArray(creds)) {
        // eslint-disable-next-line prefer-rest-params
        creds = [].slice.call(arguments);
      }

      switch (creds.length) {
        case 0:
          creds = ['', ''];
          break;

        case 1:
          creds.push('');
          break;

        case 2:
          break;

        default:
          throw new Error('auth option can only have two keys `[user, pass]`');
      }

      if (typeof creds[0] !== 'string') throw new TypeError('auth option `user` must be a string');
      if (typeof creds[1] !== 'string') throw new TypeError('auth option `pass` must be a string');

      if (!creds[0] && !creds[1]) {
        delete this.headers.Authorization;
      } else {
        this.headers.Authorization = "Basic ".concat(Buffer.from(creds.join(':')).toString('base64'));
      }

      return this;
    }
  }, {
    key: "jwt",
    value: function jwt(token) {
      if (token === null || token === undefined) delete this.headers.Authorization;else if (typeof token === 'string') this.headers.Authorization = "Bearer ".concat(token);else throw new TypeError('jwt token must be a string');
      return this;
    }
  }]);

  return Frisbee;
}();

module.exports = Frisbee;